// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SearchResults":"jg_a bhy_a bhy_j bhy_q bhy_sv bhy_sw bhy_w"};